/**
 * Environment detection — single source of truth (browser).
 *
 * Mirrors src/config/environment.ts but uses window.location.hostname
 * instead of process.env since this runs in the browser.
 */

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

/** True when running on the production host (terra.clay.com). */
export function isProduction(): boolean {
  return hostname === 'terra.clay.com' || hostname === 'www.terra.clay.com';
}

/** True when running locally (localhost or 127.0.0.1). */
export function isLocal(): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

